import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import CookieBanner from './components/CookieBanner';
import PrivacyModal from './components/PrivacyModal';
import Home from './pages/Home';
import HowToDownload from './pages/HowToDownload';
import HowToSeeUnfollowers from './pages/HowToSeeUnfollowers';
import HowToCleanUp from './pages/HowToCleanUp';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Contact from './pages/Contact';
import About from './pages/About';
import BestUnfollowTracker from './pages/BestUnfollowTracker';
import WhyAppsAreDangerous from './pages/WhyAppsAreDangerous';
import HowToImproveRatio from './pages/HowToImproveRatio';
import InstagramAccountAudit from './pages/InstagramAccountAudit';
import GoodFollowerRatio from './pages/GoodFollowerRatio';
import { CONSENT_KEY } from './config';

function App() {
  // Cookie consent: 'accepted' | 'declined' | null (undecided = show banner)
  const [consent, setConsent] = useState<'accepted' | 'declined' | null>(() => {
    const stored = localStorage.getItem(CONSENT_KEY);
    return (stored === 'accepted' || stored === 'declined') ? stored : null;
  });
  const [privacyOpen, setPrivacyOpen] = useState(false);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    setConsent('accepted');
  };

  const handleDecline = () => {
    localStorage.setItem(CONSENT_KEY, 'declined');
    setConsent('declined');
  };

  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            <Home
              consent={consent === 'accepted'}
              onPrivacyClick={() => setPrivacyOpen(true)}
            />
          }
        />
        <Route path="/how-to-download-instagram-data" element={<HowToDownload />} />
        <Route path="/how-to-see-who-doesnt-follow-you-back" element={<HowToSeeUnfollowers />} />
        <Route path="/how-to-clean-up-your-following-list" element={<HowToCleanUp />} />
        <Route path="/about" element={<About />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/best-free-instagram-unfollow-tracker" element={<BestUnfollowTracker />} />
        <Route path="/why-instagram-third-party-apps-are-dangerous" element={<WhyAppsAreDangerous />} />
        <Route path="/how-to-improve-instagram-follower-ratio" element={<HowToImproveRatio />} />
        <Route path="/instagram-account-audit" element={<InstagramAccountAudit />} />
        <Route path="/what-is-a-good-follower-following-ratio" element={<GoodFollowerRatio />} />
      </Routes>

      {/* Cookie banner — shown on all pages until user decides */}
      {consent === null && (
        <CookieBanner
          onAccept={handleAccept}
          onDecline={handleDecline}
          onPrivacyClick={() => setPrivacyOpen(true)}
        />
      )}

      {/* Privacy policy modal (quick reference from cookie banner) */}
      {privacyOpen && <PrivacyModal onClose={() => setPrivacyOpen(false)} />}
    </>
  );
}

export default App;
